import Image from '@referralexchange/rea-ui-react/src/atoms/Image';

import styles from '~/sass/atoms/ProfileCompleteBadge.module.scss';

const ProfileCompleteBadge = ({
  agent,
  isHeading = false,
  isHeaderAgent = false,
  displayNameClassName,
  className,
  noBottom,
}) => (
  <div
    className={`${styles.ProfileCompleteBadge} ${
      isHeaderAgent ? styles['--bottom'] : ''
    } ${className}`.trim()}
  >
    {isHeading ? (
      <h1 className={displayNameClassName}>{agent.display_name}</h1>
    ) : (
      <p className={displayNameClassName}>{agent.display_name}</p>
    )}
    {agent.verified_status && (
      <div
        className={`${styles['ProfileCompleteBadge__icon-wrapper']} ${
          !isHeading && !noBottom ? styles['--bottom'] : ''
        }`.trim()}
      >
        <Image
          imageSrc="/static/images/profile-complete-icon.svg"
          alt="Completed Profile"
          containerClassName={styles.ProfileCompleteBadge__icon}
        />
      </div>
    )}
  </div>
);

export default ProfileCompleteBadge;
